import React from 'react';
import { get } from './logic/functions/core/fetch';
import AppConfig, { updateConfig } from './AppConfig';
import { timingSafeEqual } from 'crypto';

type Props = {
	children: (config: any) => {};
};

type State = {
	config: any;
	error: boolean;
};

class FetchConfig extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			config: undefined,
			error: false,
		};
	}
	async componentDidMount() {
		try {
			const config = await get(`/spa/online/home/static/js/config.json`);
			updateConfig(config);
			this.setState({
				config,
			});
		} catch (Error) {
			this.setState({ error: true });
		}
	}

	public render() {
		if (this.state.error) {
			window.location.href = '/common/generic-error';
			return null;
		}
		if (this.state.config) {
			return this.props.children(AppConfig);
		}
		return null;
	}
}

export default FetchConfig;
